export default "__VITE_ASSET__A322elaW__"